// extracted by mini-css-extract-plugin
export default {"warp":"preset_apps_warp__YIf+M","home_title":"preset_apps_home_title__WCTAQ","foot":"preset_apps_foot__10EMG"};